import { REMAINING_EVENT } from "../../types";
import { getStaticOptions, localStorageTest, request } from "../../utils";
import { locationRestJobExecute } from "../../wp-api";
import { fetchStatus, getConfigurableStatusParameters, LOCAL_STORAGE_KEY_RESTORE_JOBS } from "..";
/**
 * Execute a server job. This can potentially execute more jobs by IDs to get rid
 * of requests overhead.
 */ async function executeServerJob(job, tryIds) {
    var // Our job is already processed by another worker? Perhaps another tab? Perhaps cronjob? We do not know
    _failedJob_exception_errors, _failedJob_exception;
    const { id, delay_ms } = job;
    const result = await request({
        location: locationRestJobExecute,
        request: {
            try: tryIds.join(","),
            ...getConfigurableStatusParameters()
        },
        params: {
            id
        }
    });
    const { done, failed, remaining, status } = result;
    fetchStatus({
        from: "object",
        status
    });
    // Override global state
    getStaticOptions().remaining = remaining;
    document.dispatchEvent(new CustomEvent(REMAINING_EVENT, {
        detail: {
            remaining
        }
    }));
    // Is the passed `job` failed?
    const [failedJob] = failed.filter((param)=>{
        let { id: failedId } = param;
        return failedId === id;
    });
    const [doneJob] = done.filter((param)=>{
        let { id: doneId } = param;
        return doneId === id;
    });
    if (// Check if the requested job is completely processed and retry again
    done.length === 0 && !failedJob || // Check if the requested job needs to be retried cause it failed
    failedJob && failedJob.runs <= failedJob.retries) {
        await new Promise((resolve)=>setTimeout(resolve, delay_ms));
        return executeServerJob(job, tryIds);
    }
    // Is the passed `job` completed?
    if (((failedJob == null ? void 0 : (_failedJob_exception = failedJob.exception) == null ? void 0 : (_failedJob_exception_errors = _failedJob_exception.errors) == null ? void 0 : _failedJob_exception_errors["real_queue_job_locked"]) || doneJob || failedJob && failedJob.runs > failedJob.retries) && localStorageTest()) {
        var _localStorage_getItem;
        // Remove from our localStorage, as we do not need to restore it no more
        const lsKey = `${LOCAL_STORAGE_KEY_RESTORE_JOBS}-${getStaticOptions().localStorageSuffix}`;
        const restorable = ((_localStorage_getItem = localStorage.getItem(lsKey)) == null ? void 0 : _localStorage_getItem.split(",").map(Number)) || [];
        const idx = restorable.indexOf(id);
        if (idx > -1) {
            restorable.splice(idx, 1);
        }
        localStorage.setItem(lsKey, restorable.join(","));
    }
    return result;
}
export { executeServerJob };
